import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/locales/en.json'
import ko from '@/locales/ko.json'
import pageDescKo from '@/locales/pageDescKo'
import pageDescEn from '@/locales/pageDescEn'

Vue.use(VueI18n)

const savedLocale = localStorage.getItem('tms_locale') || 'en'

export default new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    en: { ...en, pageDesc: pageDescEn },
    ko: { ...ko, pageDesc: pageDescKo },
  },
})
